import React, { useEffect, useState } from 'react';
import { Form, Button, Alert, Row, Col, Label } from "reactstrap";
import LoginError from "./loginError";
import { ButtonWithLoading, TextInputWithoutLabel } from "../../../components/common/standardComponents";

interface MfaCodeFormProps {
	isLoading: boolean;
	error: string;
	onSubmit: (code: string) => void;
	onCancel: () => void;
	onResendCode: () => Promise<void>;
}

export interface mfaCodeValues {
	code: string;
}

const initialValues: mfaCodeValues = {
	code: '',
};

export function MfaCodeForm(props: MfaCodeFormProps) {
	const { isLoading, error, onSubmit, onCancel, onResendCode } = props;

	const [infoMessage, setInfoMessage] = useState(!error ? 'Code sent!' : '');
	const [coolDown, setCoolDown] = useState<number>(0);
	const [resendError, setResendError] = useState<string>('');
	const [mfaCode, setMfaCode] = useState<string>(initialValues.code);

	useEffect(() => {
		if (coolDown > 0) {
			const timer = setInterval(() => {
				setCoolDown((prev) => {
					if (prev <= 1) {
						clearInterval(timer);
						return 0;
					}
					return prev - 1;
				});
			}, 1000);
			return () => clearInterval(timer);
		}
	}, [coolDown]);

	const handleResendCode = async () => {
		if (coolDown > 0) {
			return;
		}
		setResendError('');
		try {
			await onResendCode();
			setInfoMessage('Code resent!');
			setCoolDown(30);
		} catch (err) {
			setResendError('Failed to resend code. Please try again.');
		}
	};

	const handleSubmit = (e: any) => {
		e.preventDefault();
		setInfoMessage('');
		return onSubmit(mfaCode);
	};

	const isValid = () => {
		return mfaCode;
	}

	return (
		<div className="fadeIn">
			<div className="text-left">
				<h2>Enter Code</h2>
				{(error || resendError) && !isLoading && <LoginError isLoading={isLoading} error={error || resendError} />}
				{infoMessage && <Alert style={{ padding: '0' }} color="success">{infoMessage}</Alert>}
				<Form onSubmit={handleSubmit}>
					<Row>
						<Col lg={8}>
							<TextInputWithoutLabel
								id="mfaCode"
								value={mfaCode}
								isRequired
								placeHolder="Enter Code"
								disabled={isLoading}
								onChange={(e: any) => setMfaCode(e.target.value)}
							/>
						</Col>
						<Col lg={4}>
							<ButtonWithLoading
								isLoading={props.isLoading}
								disabled={props.isLoading}
								type="submit"
								text={"Verify"}
								loadingText="Verifying..."
								isValid={() => isValid()}
							/>
						</Col>
					</Row>
					<Row>
						<Label>Didn't receive a code?</Label>
					</Row>
					<Button color="primary" outline onClick={handleResendCode} disabled={coolDown > 0}>
						{coolDown > 0 ? `Re-send (${coolDown}s)` : 'Re-Send Code'}
					</Button>
					<span style={{margin: "0px 5px"}}>or</span>
					<Button color="primary" outline onClick={onCancel}>
						Choose a different method
					</Button>
				</Form>
			</div>
		</div>
	);
}

export default MfaCodeForm;
